// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// Material UI ( mui )  components
import Box from '@mui/material/Box';

// Section for type definition -----------------------------------------------------------------------------------------
type TabPanelProps = {
  children: React.ReactNode | null;
  index: number;
  value: number;
};

function CustomTabPanel({ children = null, value, index }: TabPanelProps): React.JSX.Element {
  return (
    <div role="tabpanel" hidden={value !== index} id={`tabPanel-${index}`} aria-labelledby={`tab-${index}`}>
      {value === index && (
        <Box sx={{ p: 3 }} className="mt-0 pt-0 px-0 pb-6 max-md:pb-4 border-b-[1px] border-rf-navy">
          {children}
        </Box>
      )}
    </div>
  );
}

export default CustomTabPanel;
